import { compose } from 'redux'
import hasActiveSelection from '../../hoc/hasActiveSelection'
import toJS from '../../hoc/toJS'
import PagesSection from '../../components/PageWebsiteSubpages/PagesSection'

const SelectionContainer = ({transId, type, activeSelection, collapseActiveSelection}) => {
    const selectionActiveClass = activeSelection === type ? "accordion-item-open" : "accordion-item-close"

    return <PagesSection    
        transId={transId}
        type={type}
        className={type}
        selectionActiveClass={selectionActiveClass}
        collapseActiveSelection={collapseActiveSelection}
    />
}

export default compose(
    hasActiveSelection(),
    toJS()
)(SelectionContainer)